__turbopack_context__.v({
  "anchor-mark": "anchor-mark-module-scss-module__SM1-qa__anchor-mark",
});
